import { render } from "./VerificationGuarantor.vue?vue&type=template&id=6aebf948&scoped=true"
import script from "./VerificationGuarantor.vue?vue&type=script&lang=js"
export * from "./VerificationGuarantor.vue?vue&type=script&lang=js"

import "./VerificationGuarantor.vue?vue&type=style&index=0&id=6aebf948&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aebf948"]])

export default __exports__